import Image from 'next/image'
import Link from 'next/link'
import Screenshot from '/public/screenshot-1.png';
import {
  ChartBarIcon,
  ClockIcon,
  CurrencyDollarIcon,
  VideoCameraIcon, 
 } from '@heroicons/react/24/outline'

const features = [
  {
    name: 'Monthly Reports.',
    description: 'These provide great status updates on your financial performance at a regular cadence.',
    icon: ClockIcon,
  },
  {
    name: 'Simple visuals.',
    description: 'We remove the headache of trying to read your financials by making it simple, effective and walking you through it.',
    icon: ChartBarIcon 
  },
  {
    name: 'Video reviews.',
    description: 'We create a custom monthly video review of your Financial Health, so you can get up to speed, on your time.',
    icon: VideoCameraIcon,
  }
]

/* This example requires Tailwind CSS v2.0+ */
export default function AppDetails() {
  return (
  <div className="mt-24 mb-24" >
    <div className="mx-auto max-w-7xl px-6 lg:px-8">
      <div className="mx-auto max-w-2xl sm:text-center">
        <h2 className="text-base font-semibold leading-7 text-pinto"></h2>
        <p className="mt-2 text-3xl font-medium tracking-tight text-gray-900 sm:text-4xl">
          How we quickly create a path to <span className="text-pinto">profitability</span>
        </p>
        <p className="mt-6 text-lg leading-8 text-gray-600">
          Get more time to grow your business using our <span className='font-semibold'>expert</span> help & software to automate your financial process. 
        </p>
        <p className='mt-6'>
          <Link
            className="transition hover:underline hover:text-pinto sm:ml-6 text-base font-semibold leading-7 text-gray-900"
            href="/demo"
          >
            See A Demo Report 
            <span aria-hidden="true"> &rarr;</span>
          </Link>
        </p> 

      </div>
    </div>
    <div className="relative overflow-hidden pt-16">
      <div className="mx-auto max-w-7xl px-6 lg:px-8">
        <Image
          src={Screenshot}
          alt="Pinto Screenshot"
          className="mb-[-12%] rounded-xl shadow-2xl ring-1 ring-gray-900/10"
          loading='lazy' 
        />
        <div className="relative" aria-hidden="true">
          <div className="absolute -inset-x-20 bottom-0 bg-gradient-to-t from-white pt-[7%]" />
        </div>
      </div>
    </div>
    <div className="mx-auto mt-16 max-w-7xl px-6 sm:mt-20 md:mt-24 lg:px-8">
      <dl className="mx-auto grid max-w-2xl grid-cols-1 gap-x-6 gap-y-10 text-base leading-7 text-gray-600 sm:grid-cols-2 lg:mx-0 lg:max-w-none lg:grid-cols-3 lg:gap-x-8 lg:gap-y-16">
        {features.map((feature) => (
          <div key={feature.name} className="relative pl-9">
            <dt className="inline font-semibold text-gray-900">
              <feature.icon className="absolute top-1 left-1 h-5 w-5 text-pinto" aria-hidden="true" />
              {feature.name}
            </dt>{' '}
            <dd className="inline">{feature.description}</dd>
          </div>
        ))}
      </dl>
    </div>
  </div >   
  )
}